import { render, staticRenderFns } from "./ForumChatThreadCardHeaderMeta.vue?vue&type=template&id=50152229&scoped=true"
import script from "./ForumChatThreadCardHeaderMeta.vue?vue&type=script&lang=js"
export * from "./ForumChatThreadCardHeaderMeta.vue?vue&type=script&lang=js"
import style0 from "./ForumChatThreadCardHeaderMeta.vue?vue&type=style&index=0&id=50152229&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50152229",
  null
  
)

export default component.exports